import React from 'react'
import { useDataUsuarioSelected } from '../../../../Hooks/Admin/useContextos';
import { CustomTable } from '../../../../Components/Admin/CustomTable';
import { useObjetosUsuariosTable, useObtenerObjetoUsuario, useEditarObjetoUsuario, useEliminarObjetoUsuario, useEliminarTotalObjetoUsuario } from '../queries/querysObjetos';
import { useFormularioObjetos } from './Hooks/Objetos/useFormularioObjetos';
import { Card } from 'antd';

export const ObjetosUsuarios = () => {
  const { selectedId } = useDataUsuarioSelected();
  const {
    columnas,
    camposFormulario,
    acciones,
    camposFormularioCrear,
    camposFormularioEditar,
    formatData
  } = useFormularioObjetos();

  if (!selectedId) {
    return <Card title="Elije un usuario para poder interactuar con esta pestaña" />;
  }

  return (
    <CustomTable
      columns={columnas}
      perPage={5}
      queryListar={useObjetosUsuariosTable}
      basicParams={{ idUsuario: selectedId, page: 1, perPage: 5 }}
      externalParams={{ idUsuario: selectedId }}
      camposFilter={camposFormulario}
      camposAgregar={camposFormularioCrear(selectedId)}
      queryCrear={useObtenerObjetoUsuario}
      editable={true}
      camposFormularioModal={camposFormularioEditar}
      queryEditar={useEditarObjetoUsuario}
      formatData={formatData}
      canDelete={true}
      queryBorrarFila={useEliminarObjetoUsuario}
      canDeleteTotal={true}
      queryBorrarTotalFila={useEliminarTotalObjetoUsuario}
    />
  );
}